export default __webpack_public_path__ + "assets/models/bab0d64290e2ec1d8b65625f26c3c43d.glb";